import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import styled from '@emotion/styled/macro'
import { Global, css } from '@emotion/react'
import theme from './theme'
import Pages from './pages'
import UserContext, { UserContextProvider } from './data/user'
import { apiService } from './api'
import React from 'react'
import { JSONToCSSVariables } from './utils/JSONToCSSVariables'
import { SocketContextProvider } from './pages/private/socket'

const Layout = styled('div')`
    background: radial-gradient(
        var(--colors-primary-lighter),
        var(--colors-primary-main)
    );
    position: fixed;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100vw;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    overflow: hidden;
    > div:nth-child(2) {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }
`

function App() {
    return (
        <React.Fragment>
            <Global
                styles={css`
                    @import url('https://fonts.googleapis.com/css2?family=Jost:wght@700&family=Montserrat:wght@100;400;500;600&display=swap');
                    :root {
                        ${JSONToCSSVariables(theme)}
                    }

                    * {
                        font-family: var(--typography-fontFamily-paragraph);
                        color: var(--colors-grays-100);
                    }
                    hr {
                        width: 100%;
                    }
                    h1,
                    h2,
                    h3,
                    h4,
                    h5,
                    h6 {
                        font-family: var(--typography-fontFamily-title);
                        margin-top: 0.75em;
                        margin-bottom: 0.25em;
                        user-select: none;
                    }
                    p,
                    strong,
                    small,
                    label,
                    span {
                        user-select: none;
                    }
                    ${['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'small'].map(
                        (item) => `
${item} {
    ${
        theme.typography.fontSizes[item]
            ? `font-size: ${theme.typography.fontSizes[item]};`
            : ''
    }
}
`
                    )}
                    /* width */
                    ::-webkit-scrollbar {
                        width: 0.5rem;
                    }

                    ::-webkit-scrollbar-track {
                        border-radius: var(--borderRadius-sm);
                    }
                    ::-webkit-scrollbar-thumb {
                        background: var(--colors-primary-accent);
                        border-radius: var(--borderRadius-sm);
                        transition: 0.4s ease all;
                        &:hover {
                            background: var(--colors-primary-main);
                        }
                    }
                `}
            />
            <Router>
                <UserContextProvider>
                    <Layout>
                        <Pages />
                    </Layout>
                </UserContextProvider>
            </Router>
        </React.Fragment>
    )
}

export default App
